import EditModeAllowedEvent from './EditModeAllowedEvent';
import EditModeBlockedEvent from './EditModeBlockedEvent';
import EditModeCloseEvent from './EditModeCloseEvent';
import EditModeOpenEvent from './EditModeOpenEvent';
import EditModeSaveEvent from './EditModeSaveEvent';

const EditModeEvents = {
  Allowed: EditModeAllowedEvent,
  Blocked: EditModeBlockedEvent,
  Close: EditModeCloseEvent,
  Open: EditModeOpenEvent,
  Save: EditModeSaveEvent,
};

export default EditModeEvents;
